import { type UseQueryResult, useQuery } from 'react-query';

import { PagedResultDto_TrustedDeviceDto } from '../../services/wealthlane-identity-services/models/PagedResultDto_TrustedDeviceDto';
import { TrustedDeviceService } from '../../services/wealthlane-identity-services/services/TrustedDeviceService';

const useGetTrustedDevices = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<PagedResultDto_TrustedDeviceDto | undefined, unknown> => {
  return useQuery(['getTrustedDevices'], async () => {
    return await handleRequest(
      TrustedDeviceService.getApiIdentityApiAppTrustedDevice(undefined, 0, 100)
    );
  });
};

export default useGetTrustedDevices;
